export const result =
    {
        "pie1": [
            {
                "area": "не соответствует",
                "bill": 38
            },
            {
                "area": "соответствует",
                "bill": 2
            },
        ],
        "pie2": [
            {
                "area": "не соответствует",
                "value": 36
            },
            {
                "area": "соответствует",
                "value": 4
            },
        ]
    }
